import { render, staticRenderFns } from "./GastroAnoRettoColonscopiaView.vue?vue&type=template&id=4e99bd5e"
import script from "./GastroAnoRettoColonscopiaView.vue?vue&type=script&lang=js"
export * from "./GastroAnoRettoColonscopiaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports